import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter as Router} from "react-router-dom";
import {msalInstance} from "./authConfig";
import {MsalProvider} from "@azure/msal-react";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Awaited here so the redirect callback is fully processed, and every
// interceptor/component reading this same instance sees a ready account
// cache, before anything in the tree can mount and fire a request.
const renderApp = () =>
  root.render(
    <Router>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    </Router>,
  );

msalInstance
  .initialize()
  .then(renderApp)
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
    renderApp();
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
